"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
const SelectPlayerRow_vue_1 = require("@/client/components/SelectPlayerRow.vue");
exports.default = vue_1.default.extend({
    name: 'SelectDelegate',
    props: {
        players: {
            type: Array,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selectedPlayer: undefined,
        };
    },
    components: {
        AppButton: AppButton_vue_1.default,
        'select-player-row': SelectPlayerRow_vue_1.default,
    },
    methods: {
        saveData() {
            if (this.selectedPlayer !== undefined) {
                this.onsave({ type: 'delegate', player: this.selectedPlayer });
            }
        },
    },
});
